<template>
  <v-app>
    <dashboard-core-app-bar v-model="expandOnHover" />
    <div class="d-flex">
      <multi-org-drawer v-if="isMultiOrg && !$vuetify.breakpoint.mobile" />
      <main-nav
        :style="isMultiOrg && !$vuetify.breakpoint.mobile ? 'margin-left: 74px' : null"
      />
    </div>
    <account-drawer />
    <dashboard-core-view />
  </v-app>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { OCCUPANCY } from '../helpers/feature-constants'
  export default {
    name: 'DashboardIndex',
    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      MultiOrgDrawer: () => import('./components/core/MultiOrgDrawer'),
      AccountDrawer: () => import('./components/core/AccountDrawer'),
      MainNav: () => import('./components/core/Drawer'),
      DashboardCoreView: () => import('./components/core/View'),
    },
    data: () => ({
      expandOnHover: false,
      drawer: false,
    }),
    computed: {
      ...mapGetters({
        isMultiOrg: 'Permissions/isMultiOrg',
        currentUser: 'Users/currentUser',
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
        canAdminSelectedOrg: 'Permissions/canAdminSelectedOrg',
        eligibleFeatures: 'Organizations/eligibleFeatures',
      }),
      occupancyEligible () {
        return this.eligibleFeatures.includes(OCCUPANCY)
      },
    },
    methods: {
      handleCloseDrawer () {
        this.drawer = false
      },
    },
  }
</script>
